import { render, staticRenderFns } from "./CarouselFigureList.vue?vue&type=template&id=25282fe6&scoped=true"
import script from "./CarouselFigureList.vue?vue&type=script&lang=js"
export * from "./CarouselFigureList.vue?vue&type=script&lang=js"
import style0 from "./CarouselFigureList.vue?vue&type=style&index=0&id=25282fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25282fe6",
  null
  
)

export default component.exports